module.exports = __webpack_public_path__ + "static/salestax-compliance-9e3d926595da732006d3aa7288bac57b.svg";